import React from 'react';
import EmailAddress from '../scripts/EmailAddress';
import Me from '../images/james-fawcett.png';
import WhatsappImage from '../images/whatsapp.svg';
import LinkedinImage from '../images/linkedin.svg';
import GithubImage from '../images/github.svg';
import WhatsappBtn from '../images/whatsapp-btn.svg';
// import TwitterImage from '../images/twitter-x.svg';
import WithConsumer from '../context/WithConsumer';
// import AdSense from 'react-adsense';

import $ from 'jquery'; // @todo - redo this without jquery

const Head = ({index,context}) => {

    const bIsHomepage = context.restType === 'home' ? true : false;
    const bIsSitemap = context.restType === 'sitemap' ? true : false;
    const bIsPrivacy = context.slug === 'privacy-policy' ? true : false;

    $(function() {

      var $sidebar   = $(".profile-holder"),
          $window    = $(window),
          offset     = $sidebar.offset(),
          topPadding = 15;

      $window.scroll(function() {

          if ($window.scrollTop() > offset.top) {
            // Only if content area is tall
            // if ($('.content-area').height() > 700) {
              // if ($window.scrollTop() < 1000) { // Only do up to 500

                // Work out space left undernieth sidebar
                // var space = $window.innerHeight - $sidebar.offsetTop + $sidebar.offsetHeight;
                var space = $window.scrollTop() - offset.top + $sidebar.height();

                // console.log('space:', space);
                // console.log('offset.top:', offset.top);
                // console.log('$sidebar.height():', $sidebar.height());
                // console.log('$window.innerHeight:', $window.innerHeight);

                if (space > 100) {

                  $sidebar.stop().animate({
                      marginTop: $window.scrollTop() - offset.top + topPadding
                  });

                // }
              // }
            }
          } else {
              $sidebar.stop().animate({
                  marginTop: 0
              });
          }
      });

  });

    return (<div className="profile-holder">
          <div className="profile">
          <a href="https:\/\/www.jamesfawcett.co.uk">
          <img
          width="100"
          height="100"
          alt="James Fawcett"
          className="profile__me" 
          src={Me}
          />
          <span className="profile__name">
          James Fawcett
          </span>
          <span className="profile__job">Freelance Advanced Wordpress Developer/PHP/Javascript</span>
          </a>
          <br/>
          <div>
          <EmailAddress />
          </div>

          <a className="whatsapp-btn" aria-label="Chat on WhatsApp" href="https://wa.me/7478677588">
            <img alt="Chat on WhatsApp" src={WhatsappBtn} />
          </a>

          <a aria-label="Chat on WhatsApp" href="https://wa.me/7478677588"> 
          <img 
          alt="Chat on WhatsApp" 
          src={WhatsappImage}
          width="28"
          height="28"
          className="profile__icon"
          />
          </a>

          <a aria-label="Github" target="_blank" rel="noopener noreferrer" href="https://github.com/jamesfawcett"> 
          <img 
          alt="Github" 
          src={GithubImage}
          width="28"
          height="28"
          className="profile__icon"
          />
          </a>

          <a target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" href="https://www.linkedin.com/in/jamesdfawcett/"> 
          <img 
          alt="Linkedin Logo" 
          src={LinkedinImage}
          width="28"
          height="28"
          className="profile__icon"
          />
          </a>

          {/* <a target="_blank" rel="noopener noreferrer" aria-label="Twitter" href="https://twitter.com/jamesfawcettuk"> 
          <img 
          alt="Twitter Logo" 
          src={TwitterImage}
          width="28"
          height="28"
          className="profile__icon"
          />
          </a> */}

          {/* {(bIsHomepage !== true && bIsSitemap !== true && bIsPrivacy !== true) && (
           <form action="https:\/\/www.paypal.com\/cgi-bin\/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_donations" />
            <input type="hidden" name="business" value="2020@jamesfawcett.co.uk" />
            <input type="hidden" name="lc" value="GB" />
            <input type="hidden" name="item_name" value="Help with server costs" />
            <input type="hidden" name="amount" value="2.00" />
            <input type="hidden" name="currency_code" value="GBP" />
            <input type="hidden" name="no_note" value="0" />
            <input type="hidden" name="bn" value="PP-DonationsBF:btn_donate_SM.gif:NonHostedGuest" />
            <span className="profile__donate-text"> <br />Hope that I have helped you! <br /><strong>Please feel free to help with server costs</strong></span>
            <input type="image" src="https:\/\/www.paypalobjects.com/en_GB/i/btn/btn_donate_SM.gif" border="0" name="submit" alt="PayPal – The safer, easier way to pay online." />
            <img alt="" border="0" src="https:\/\/www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1" />
            </form>
            )} */}
          
          </div>


          {/* {(bIsHomepage !== true && bIsSitemap !== true && bIsPrivacy !== true) && (
          <AdSense.Google
            client='ca-pub-3276901794463124'
            slot='7242938658'
            style={{ width: 250, height: 300 }}
            // layout='in-article'
            format=''
          />
          )} */}

        </div>)
}
export default WithConsumer(Head);